import { render } from "./Table.Shimmer.vue?vue&type=template&id=d0808aa8&scoped=true"
import script from "./Table.Shimmer.vue?vue&type=script&lang=js"
export * from "./Table.Shimmer.vue?vue&type=script&lang=js"

import "./Table.Shimmer.vue?vue&type=style&index=0&id=d0808aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0808aa8"]])

export default __exports__